module.exports = __webpack_public_path__ + "img/4-2.ee33a421.png";